export class CristieError extends Error {
  status: number;
  message: string;
  description: string;
  httpErrorCode: number;
  type: string;
  errorCode: string; // It would be nice to start adding error codes into our errors so we can just stick them on the forum
  possibleValues: string;

  constructor(status: number, type: string, message: string, errorCode: string, possibleValues?: string) {
    super(message);
    this.status = status;
    this.message = message;
    this.description = message;
    this.httpErrorCode = status;
    this.type = type;
    this.errorCode = errorCode;
    this.possibleValues = possibleValues;
  }
}
